import { ModelValidatorBase } from './model.validator.base';
import { Expression, BasicExpression } from 'app/model/dataflow/expressionTypes';
import { DataFlowFunctionArgument } from 'app/model/dataflow/dataflow-function-argument';
import { DataFlowExpressionFunctions } from 'app/model/dataflow/dataflow-expression-functions';


export class RequiredFunctionValidator extends ModelValidatorBase {

    public constructor(private requiredFunctions: DataFlowFunctionArgument[]) {
        super();
    }

    public visitColumnOperandRef(expression: Expression): void {
        this.invalidExpressions.set(expression, expression);
    }

    public visitColumnOperand(expression: Expression): void {
        this.invalidExpressions.set(expression, expression);
    }

    public visitFunctionExpr(expression: Expression): void {
        if (this.requiredFunctions.findIndex((func) => func.name === expression.functionExpression.basicName.identifier.name) > -1) {
            return;
        }
        super.visitFunctionExpr(expression);
    }
    public getErrorMessage(expression: BasicExpression): string {
        if (this.requiredFunctions.findIndex((func) => func.name === DataFlowExpressionFunctions.WINDOW_FUNCTIONS[0].name) > -1) {
            return stringResources.NoWindowFunctionWrappedError;
        }

        return stringResources.NoAggregateFunctionWrappedError;
    }
}
